export const CONSENT_COOKIE_NAME = "consent";

/**
 * Versión de la política de cookies.
 * Hacer bump cuando cambien los textos legales para poder reacreditar consentimientos.
 */
export const CONSENT_POLICY_VERSION = "2026-08-26";

export const VISITOR_ID_STORAGE_KEY = "visitor-id";
export const CONSENT_PROOF_STORAGE_KEY = "consent-proof";
